import { useTranslation } from 'react-i18next'

import { getCurrentMarketConfig } from '../../../../../services/market-service'
import './applicant-info.scss'

const ApplicantInfo = (applicant: {
  height: number | null
  languages: string[] | null
  years_experience: number | null
  age: number | null
  nationality: string | null
  gender: string | null
  location: string | null
}) => {
  const { t } = useTranslation()

  const getFields = () => {
    const experience = {
      lbl: t('job_cherry_picking.experience'),
      value: `${applicant.years_experience} ${t('job_draft_details.experience_years')}`,
    }

    const initialFields: {
      lbl: string
      value: string | number
    }[] = applicant.years_experience ? [experience] : []
    if (getCurrentMarketConfig().applicantReview.includeNationality && applicant.nationality?.length) {
      initialFields.push({ lbl: t('job_cherry_picking.nationality'), value: applicant.nationality })
    }
    if (applicant.languages !== null && Array.isArray(applicant.languages)) {
      const filteredLanguages = applicant.languages.filter(l => l.length > 0)
      if (filteredLanguages.length > 0) {
        initialFields.push({ lbl: t('job_cherry_picking.language'), value: applicant.languages.join(', ') })
      }
    }
    if (getCurrentMarketConfig().applicantReview.includeHeight && applicant.height !== null) {
      initialFields.push({
        lbl: t('job_cherry_picking.height'),
        value: t('job_cherry_picking.height_cm', { count: applicant.height }),
      })
    }
    if (applicant.age !== null) {
      initialFields.push({
        lbl: t('job_cherry_picking.age'),
        value: t('job_cherry_picking.years_old', { count: applicant.age }),
      })
    }
    if (applicant.gender !== null) {
      initialFields.push({
        lbl: t('job_cherry_picking.gender'),
        value: applicant.gender,
      })
    }
    if (applicant.location !== null) {
      initialFields.push({
        lbl: t('job_cherry_picking.location'),
        value: applicant.location,
      })
    }

    return initialFields
  }

  return (
    <div className="ApplicantInfo">
      {getFields().map(field => (
        <div className="ApplicantInfo__row" key={field.lbl}>
          <h3 className="ApplicantInfo__label">{field.lbl}</h3>
          <p className="ApplicantInfo__data">{field.value}</p>
        </div>
      ))}
    </div>
  )
}

export default ApplicantInfo
